var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 12.5C3.72386 12.5 3.5 12.7239 3.5 13V19C3.5 19.2761 3.72386 19.5 4 19.5H8C8.27614 19.5 8.5 19.2761 8.5 19V13C8.5 12.7239 8.27614 12.5 8 12.5H4ZM2.5 13C2.5 12.1716 3.17157 11.5 4 11.5H8C8.82843 11.5 9.5 12.1716 9.5 13V19C9.5 19.8284 8.82843 20.5 8 20.5H4C3.17157 20.5 2.5 19.8284 2.5 19V13Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 8.5C9.72386 8.5 9.5 8.72386 9.5 9V19C9.5 19.2761 9.72386 19.5 10 19.5H14C14.2761 19.5 14.5 19.2761 14.5 19V9C14.5 8.72386 14.2761 8.5 14 8.5H10ZM8.5 9C8.5 8.17157 9.17157 7.5 10 7.5H14C14.8284 7.5 15.5 8.17157 15.5 9V19C15.5 19.8284 14.8284 20.5 14 20.5H10C9.17157 20.5 8.5 19.8284 8.5 19V9Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 4.5C15.7239 4.5 15.5 4.72386 15.5 5V19C15.5 19.2761 15.7239 19.5 16 19.5H20C20.2761 19.5 20.5 19.2761 20.5 19V5C20.5 4.72386 20.2761 4.5 20 4.5H16ZM14.5 5C14.5 4.17157 15.1716 3.5 16 3.5H20C20.8284 3.5 21.5 4.17157 21.5 5V19C21.5 19.8284 20.8284 20.5 20 20.5H16C15.1716 20.5 14.5 19.8284 14.5 19V5Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 20C3.5 19.7239 3.72386 19.5 4 19.5H18C18.2761 19.5 18.5 19.7239 18.5 20C18.5 20.2761 18.2761 20.5 18 20.5H4C3.72386 20.5 3.5 20.2761 3.5 20Z",
    fill: "current"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.d015f2a9687ef42611e424da208d398e.svg";
export { ForwardRef as ReactComponent };